module.exports = __webpack_public_path__ + "img/vertical_3_1_8011.b0462963.png";